module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full flex flex-col"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "max-height-container border-solid border-gray-200 bg-white border-b border-r border-l rounded-b-lg py-3 px-3"
  }, [_c('StudentMakeNotesTextArea')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex bg-white border h-10 border-solid border-gray-200 px-4 py-2 rounded-t-lg justify-between items-center"
  }, [_c('span', [_vm._v("Notepad")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2605206c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/PromptSideBarStudentNotepad.vue
// module id = 1845
// module chunks = 61